<template>
  <div>
    <v-row class="mx-2">
      <v-col cols="12" md="6" class="pa-0">
        <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
          <v-tab
            :disabled="loading"
            v-for="tab in tabList"
            :key="tab.id"
            @click="changeTab(tab)"
            >{{ tab.name }}</v-tab
          >
        </v-tabs>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="12" md="6" class="d-flex justify-space-between">
        <v-text-field
          v-model="search"
          outlined
          prepend-inner-icon="search"
          label="Search"
          single-line
          hide-details
          class="rounded-lg"
          color="#239FAB"
          dense
        ></v-text-field>

        <v-btn
          class="white--text ml-2 rounded-lg"
          color="#519043"
          @click="add_late_filing()"
        >
          Add Late Filing
        </v-btn>
        <v-btn
          class="white--text ml-2 rounded-lg"
          color="#519043"
          @click="filterDialog = true"
        >
          Print
        </v-btn>
      </v-col>
    </v-row>
    <v-card class="ma-5 dt-container" elevation="0" outlined>
      <v-data-table
        :headers="tab != 2 && tab != 3 ? headers : headers1"
        :items="data"
        :items-per-page="10"
        :search="search"
        :options.sync="options"
        :loading="loading"
        @pagination="pagination"
        hide-default-footer
      >
        <template v-slot:[`item.to_names`]="{ item }">
          <div :inner-html.prop="item.to_names | highlight(search)"></div>
        </template>
        <template v-slot:[`item.travel_date_from`]="{ item }">
          {{ formatTravelDate(item) }}
        </template>

        <template v-slot:[`item.is_recommending_approval_approved`]="{ item }">
          <v-chip
            v-if="item.is_recommending_approval_approved == 1"
            class="ma-2"
            x-small
          >
            For Approval
          </v-chip>
          <v-icon
            color="#519043"
            v-if="item.is_recommending_approval_approved == 2"
            >mdi-check-bold</v-icon
          >

          <v-icon
            color="error"
            v-if="item.is_recommending_approval_approved == 3"
            >mdi-timer-refresh-outline</v-icon
          >
        </template>

        <template v-slot:[`item.is_finance_dir_approved`]="{ item }">
          <v-chip v-if="item.is_finance_dir_approved == 1" class="ma-2" x-small>
            For Approval
          </v-chip>
          <v-icon color="#519043" v-if="item.is_finance_dir_approved == 2"
            >mdi-check-bold</v-icon
          >

          <v-icon color="error" v-if="item.is_finance_dir_approved == 3"
            >mdi-timer-refresh-outline</v-icon
          >
        </template>

        <template v-slot:[`item.is_president_approved`]="{ item }">
          <v-chip v-if="item.is_president_approved == 1" class="ma-2" x-small>
            For Approval
          </v-chip>
          <v-icon color="#519043" v-if="item.is_president_approved == 2"
            >mdi-check-bold</v-icon
          >

          <v-icon color="error" v-if="item.is_president_approved == 3"
            >mdi-timer-refresh-outline</v-icon
          >
        </template>
        <template v-slot:[`item.tar_deadline`]="{ item }">
          {{ formatDate(item.deadline_for_tar) }} <br />
          {{
            item.isDeadlineExtended
              ? "Extended Deadline: " +
                formatDate(item.deadline_extension_for_tar)
              : ""
          }}
        </template>

        <template v-slot:[`item.tar_status`]="{ item }">
          <div
            v-for="(i, a) in item.tarSubmitter"
            :key="a"
            class="d-flex justify-space-between align-start"
          >
            <div class="text-caption text-left align-center">
              {{ i.name }}
            </div>
            <div class="d-flex">
              <v-chip
                v-if="i.status == null"
                color=" "
                class="align-self-center"
                x-small
              >
                For Submission
              </v-chip>
              <v-chip
                v-if="i.status == 1"
                color="blue"
                class="white--text align-self-center"
                x-small
              >
                For Approval
              </v-chip>
              <v-chip
                v-if="i.status == 2"
                color="#519043"
                class="white--text align-self-center"
                x-small
              >
                Approved
              </v-chip>
              <v-chip
                v-if="i.status == 3"
                color="error"
                class="white--text align-self-center"
                x-small
              >
                Pending
              </v-chip>
            </div>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <div class="">
            <!-- <div class="d-flex justify-space-evenly">  -->
            <v-btn
              block
              class="ma-1"
              v-if="
                item.travel_subtype != 1 && tab != 1 && tab != 5 && tab != 4
              "
              x-small
              color="grey"
              outlined
              @click="resetDeadLine(item)"
            >
              <v-icon size="14">mdi-pencil</v-icon> Reset TAR deadline
            </v-btn>
            <v-btn
              block
              class="ma-1"
              v-if="tab != 5 && tab != 4"
              x-small
              color="grey"
              outlined
              @click="updateItem(item)"
            >
              <v-icon size="14">mdi-pencil</v-icon> Edit
            </v-btn>
            <v-btn
              block
              class="ma-1"
              x-small
              color="grey"
              outlined
              @click="editItem(item)"
            >
              <v-icon size="14">mdi-eye</v-icon> View
            </v-btn>
            <v-btn
              v-if="tab != 5"
              x-small
              block
              class="mx-1"
              color="red"
              outlined
              @click="cancelTO(item)"
            >
              <v-icon size="14">mdi-cancel</v-icon> Cancel
            </v-btn>
            <v-btn
              block
              class="ma-1"
              v-if="tab != 5"
              x-small
              color="#519043"
              outlined
              @click="printItem(item)"
            >
              <v-icon size="14">mdi-printer</v-icon> Print TO
            </v-btn>
            <v-btn
              block
              class="ma-1"
              v-if="tab != 5"
              x-small
              color="#519043"
              outlined
              @click="openTARSubmitters(item)"
            >
              <v-icon size="14">mdi-printer</v-icon> Print TAR
            </v-btn>
            <v-btn
              block
              class="ma-1"
              v-if="tab == 5 && item.filename"
              x-small
              color="#519043"
              outlined
              @click="viewCancelledTO(item)"
            >
              <v-icon size="14">mdi-eye</v-icon> View Attachment
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <v-row class="mb-2 mx-5" align="center">
      <v-col cols="auto" class="mr-auto text-truncate flex-items" no-gutters>
        <span class="px-2">Show</span>
        <span>
          <v-select
            dense
            outlined
            color="#519043"
            hide-details
            :value="options.itemsPerPage"
            style="max-width: 90px"
            class="rounded-lg"
            @change="options.itemsPerPage = parseInt($event, 10)"
            :items="perPageChoices"
          >
          </v-select>
        </span>
        <span class="px-2"> Entries </span>
      </v-col>

      <v-col cols="auto" class="mr-auto text-truncate" no-gutters>
        Showing {{ paginationData.pageStart + 1 }} to
        {{ paginationData.pageStop }} of
        {{ paginationData.itemsLength }} entries
      </v-col>
      <v-col cols="auto">
        <v-pagination
          v-model="options.page"
          class="rounded-lg"
          :total-visible="7"
          :color="$vuetify.theme.themes.light.submitBtns"
          :length="paginationData.pageCount"
        >
        </v-pagination>
      </v-col>
    </v-row>

    <ViewTravelOrderAttachments
      :data="updateData"
      :action="action"
      :tab="tab"
    />
    <ViewTravelOrderToUpdateDialog :data="viewData" :action="action" />
    <!-- reset deadline -->
    <v-dialog v-model="resetDeadlineDialog" persistent max-width="500">
      <v-card color="white">
        <v-form ref="resetDeadlineDialogFormref" @submit.prevent>
          <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
            <span>Reset deadline</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="resetDeadlineDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="mt-2" cols="12">
                  <v-menu
                    ref="deadlineDateFromRef"
                    :close-on-content-click="false"
                    :return-value.sync="deadline_date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        outlined
                        dense
                        v-model="deadline_date"
                        :rules="[formRules.required]"
                        chips
                        readonly
                        small-chips
                        color="#6DB249"
                        label="New Deadline for adding TAR"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="deadline_date"
                      :min="
                        new Date(travel_date_to).toISOString().substr(0, 10)
                      "
                      no-title
                      color="#6DB249"
                      scrollable
                    >
                      <v-spacer></v-spacer>

                      <v-btn
                        text
                        color="#6DB249"
                        @click="$refs.deadlineDateFromRef.save(deadline_date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="deadlineToAddTARDialog = false">
              Close
            </v-btn>
            <v-btn
              color="green"
              class="white--text"
              @click="saveDeadlineDate()"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h5"> Confirmation </v-card-title>

        <v-card-text style="font-size: 17px">
          Are you sure you want to delete this item ?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="teal darken-3"
            outlined
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>

          <v-btn
            color="teal darken-3"
            class="white--text"
            @click="
              confirmDelete();
              dialogConfirmDelete = false;
            "
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- cancellation of TO dialog -->
    <v-dialog
      v-model="cancelTravelOrderDialog"
      persistent
      max-width="420"
      content-class="confirm-dialog"
    >
      <v-card class="confirm-card">
        <!-- Gradient Header -->
        <div class="dialog-header">
          <div class="header-icon">
            <v-icon color="white">mdi-alert-outline</v-icon>
          </div>
          <div class="header-title">Warning</div>
        </div>

        <v-card-text class="dialog-body">
          <p class="confirm-text">
            Are you sure you want to <b>cancel</b> this Travel Order?
          </p>
          <p class="confirm-subtext">
            This action cannot be undone.
          </p>
        </v-card-text>

        <v-card-actions class="dialog-footer">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            rounded
            color="grey darken-1"
            @click="cancelTravelOrderDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            rounded
            depressed
            color="error"
            class="white--text px-6"
            @click="confirmCancel()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- TAR submitters -->
    <v-dialog
      v-model="tarSubmitterDialog"
      scrollable
      persistent
      max-width="900"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <span>Please select employee's TAR to print</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="tarSubmitterDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col> </v-col>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="tarDialogHeaders"
                :items="tarSubmitters"
                :items-per-page="10"
              >
                <template v-slot:[`item.date_submitted`]="{ item }">
                  {{ formatDate(item.date_submitted) }}
                </template>
                <template v-slot:[`item.status`]="{ item }">
                  <v-chip
                    v-if="item.status == null"
                    color=" "
                    class="align-self-center"
                    x-small
                  >
                    For Submission
                  </v-chip>
                  <v-chip
                    v-if="item.status == 1"
                    color="blue"
                    class="white--text align-self-center"
                    x-small
                  >
                    For Approval
                  </v-chip>
                  <v-chip
                    v-if="item.status == 2"
                    color="#519043"
                    class="white--text align-self-center"
                    x-small
                  >
                    Approved
                  </v-chip>
                  <v-chip
                    v-if="item.status == 3"
                    color="error"
                    class="white--text align-self-center"
                    x-small
                  >
                    Pending
                  </v-chip>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    outlined
                    color="green"
                    class="mx-1"
                    x-small
                    :disabled="item.tarID == null"
                    @click="viewTarAttachment(item.tarID)"
                    ><v-icon size="14">mdi-eye</v-icon>View TAR
                    Attachment</v-btn
                  >
                  <v-btn
                    @click="printTAR(item.id)"
                    outlined
                    :color="item.status == 2 ? 'green' : '#519043'"
                    class="white--text"
                    :disabled="item.status != 2"
                    x-small
                    ><v-icon size="14">mdi-printer</v-icon>Print</v-btn
                  >
                </template></v-data-table
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

    <!-- TAR ATTACHMENT SELECTION dialog -->
    <v-dialog v-model="tarAttachSelectionDialog" persistent max-width="700">
      <v-card color="white">
        <div class="pa-10 #3a3b3a--text">
          <div class="text-body-1 mb-1 d-flex justify-space-around">
            <div
              class="elevation-2 text-center"
              style="width: 200px; height: 200px; cursor: pointer"
              v-for="(item, i) in files_to_display"
              :key="i"
              @click="openAttachment(item.filename)"
            >
              <v-icon color="green" size="100">mdi-file</v-icon>
              <br />
              <div class="text-caption mt-2">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>

    <!-- edit selection -->
    <v-dialog v-model="editSelectionDialog" max-width="700" scrollable>
      <v-card>
        <v-card-title class="text-h5 elevation-1"
          >Please Select Type of Editing</v-card-title
        >

        <v-card-text style="font-size: 17px">
          <div class="pa-4 #3a3b3a--text">
            <v-row style="height: 280px">
              <v-col cols="12" md="6" class="text-center">
                <div
                  class="text-h6 rounded-lg submission"
                  @click="showToEdit(1)"
                >
                  <div>
                    <v-icon size="180" color="#519043">mdi-file-account</v-icon>
                  </div>
                  <div
                    class="submission-text"
                    style="position: absolute; bottom: 0; left: 0; right: 0"
                  >
                    Dates/Employees/Purpose
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6" class="text-center">
                <div
                  class="text-h6 rounded-lg submission"
                  @click="showToEdit(2)"
                >
                  <div>
                    <v-icon size="180" color="#519043"
                      >mdi-file-document-edit</v-icon
                    >
                  </div>
                  <div
                    class="submission-text"
                    style="position: absolute; bottom: 0; left: 0; right: 0"
                  >
                    Change Travel Type
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red"
            outlined
            @click="
              editSelectionDialog = false;
              itemToEdit = null;
            "
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="filterDialog" persistent max-width="650">
      <v-card color="white">
        <v-card-title class="text-h6 mb-1 dialog-header" dark
          >Filter by Date</v-card-title
        >
        <v-card-text class="text-body-1 mb-1">
          <span style="text-align: justify">
            Please select the date range.
          </span>
          <div class="pa-4 #3a3b3a--text">
            <div class="d-flex align-center">
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :return-value.sync="date_from"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_from"
                    label="Date From"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    class="rounded-lg"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_from"
                  no-title
                  scrollable
                  color="#519043"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#519043" @click="menu1 = false"
                    >Cancel</v-btn
                  >
                  <v-btn
                    text
                    color="#519043"
                    @click="$refs.menu1.save(date_from)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>

              <span class="mx-2 text--disabled">–</span>

              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date_to"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="!date_from"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="date_to"
                    label="Date To"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    dense
                    hide-details
                    clearable
                    class="rounded-lg"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="date_to"
                  no-title
                  scrollable
                  color="#519043"
                  :min="date_from"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="#519043" @click="menu = false"
                    >Cancel</v-btn
                  >
                  <v-btn text color="#519043" @click="$refs.menu.save(date_to)"
                    >OK</v-btn
                  >
                </v-date-picker>
              </v-menu>
            </div>
          </div>
        </v-card-text>

        <!-- <v-card-title class="text-h5">
              Are you sure you want to proceed?
            </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="filterDialog = false">
            Close
          </v-btn>
          <v-btn
            v-if="date_to"
            color="#147452"
            class="white--text"
            @click="
              generateTraveOrderApprovedApplication();
              filterDialog = false;
            "
          >
            Print
          </v-btn>
        </v-card-actions>
      </v-card></v-dialog
    >

    <v-dialog
      v-model="cancelDialog"
      max-width="620"
      persistent
      scrollable
      content-class="cancel-dialog"
    >
      <v-card class="cancel-card">
        <!-- Gradient Header -->
        <v-card-title class="dialog-header">
          <div class="header-left">
            <div class="header-icon">
              <v-icon color="white">mdi-close-circle-outline</v-icon>
            </div>
            <div>
              <div class="header-title">Cancel Travel Order</div>
              <div class="header-subtitle">
                Fill in the required information below
              </div>
            </div>
          </div>
          <v-btn
            icon
            small
            class="close-btn"
            :disabled="loading"
            @click="cancelDialog = false"
          >
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form ref="cancelForm" v-model="valid">
            <v-card-text class="dialog-body">
              <!-- Reason Section -->
              <div class="section-card">
                <div class="section-header">
                  <v-icon color="error" small class="mr-2"
                    >mdi-text-box-outline</v-icon
                  >
                  <span class="section-title">Reason for Cancellation</span>
                </div>
                <div class="section-desc">
                  Explain clearly why this travel order needs to be cancelled.
                </div>

                <v-textarea
                  v-model="cancel.reason"
                  outlined
                  dense
                  placeholder="e.g. Conference postponed by the organizer"
                  rows="4"
                  auto-grow
                  counter="500"
                  maxlength="500"
                  :rules="reasonRules"
                  required
                  class="mt-3"
                ></v-textarea>
              </div>

              <!-- Attachment Section -->
              <div class="section-card">
                <div class="section-header">
                  <v-icon color="error" small class="mr-2"
                    >mdi-paperclip</v-icon
                  >
                  <span class="section-title">Supporting Attachment</span>
                </div>
                <div class="section-desc">
                  Attach proof or documentation supporting this cancellation.
                </div>

                <v-file-input
                  v-model="cancel.attachment"
                  outlined
                  dense
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  placeholder="Upload PDF"
                  accept=".pdf"
                  show-size
                  hint="Accepted formats: PDF"
                  persistent-hint
                  :rules="attachmentRules"
                  required
                  class="mt-3"
                ></v-file-input>
              </div>

              <v-alert
                dense
                text
                type="warning"
                icon="mdi-alert-outline"
                class="mb-0"
              >
                This action cannot be undone once submitted.
              </v-alert>
            </v-card-text>
          </v-form>
        </v-card-text>
        <!-- Footer -->
        <v-card-actions class="dialog-footer">
          <v-spacer></v-spacer>
          <v-btn
            outlined
            rounded
            color="grey darken-1"
            :disabled="loading"
            @click="cancelDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            rounded
            depressed
            color="#147452"
            class="px-6 white--text"
            :loading="loading"
            :disabled="!valid"
            @click="submitCancellation"
          >
            Submit Cancellation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ViewAttachment :data="tarFileName" :moduleFrom="'TAR'" />
    <LateFilingTravelOrderDialog :data="late_filing" :action="action" />
    <UpdateTravelOrderTypeDialog :data="dataToUpdateType" :action="action" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>
<script>
export default {
  components: {
    ViewTravelOrderAttachments: () =>
      import("../../components/Dialogs/Views/ViewTravelOrderAttachments.vue"),
    ViewTravelOrderToUpdateDialog: () =>
      import(
        "../../components/Dialogs/Views/ViewTravelOrderToUpdateDialog.vue"
      ),
    ViewAttachment: () =>
      import("../../components/Dialogs/Views/ViewAttachment.vue"),
    LateFilingTravelOrderDialog: () =>
      import("../../components/Dialogs/Forms/LateFilingTravelOrderDialog.vue"),
    UpdateTravelOrderTypeDialog: () =>
      import("../../components/Dialogs/Forms/UpdateTravelOrderTypeDialog.vue"),
  },
  filters: {
    highlight: function(value, query) {
      return value.replace(
        new RegExp(query, ""),
        "<span class='blue'>" + query + "</span>",
      );
    },
  },
  data: () => ({
    search: "",
    cancelDialog: false,
    valid: false,
    menu: null,
    menu1: null,
    cancel: {
      reason: "",
      attachment: null,
    },
    reasonRules: [
      (v) => !!v || "Reason is required.",
      (v) => (v && v.length >= 10) || "Reason must be at least 10 characters.",
    ],

    attachmentRules: [(v) => !!v || "Attachment is required."],
    filterDialog: false,
    date_to: null,
    date_from: null,
    editSelectionDialog: false,
    itemToEdit: null,
    dataToUpdateType: null,
    deadline_date: null,
    resetDeadlineDialog: false,
    travel_date_to: null,
    to_ID: null,
    late_filing: null,
    files_to_display: [],
    tarAttachSelectionDialog: false,
    headers: [
      { text: "TO Number", value: "travel_order_num", align: "start" },
      // { text: "Created By", value: "name", align: "start" },
      { text: "Employee/s", value: "to_names", align: "start", width: 180 },
      {
        text: "Date of Travel",
        value: "travel_date_from",
        align: "start",
        width: 100,
      },
      {
        text: "Place/s of Travel",
        value: "travel_place",
        align: "start",
        width: 180,
      },
      { text: "Purpose", value: "travel_purpose", align: "start", width: 180 },
      {
        text: "Recommending Approval",
        value: "is_recommending_approval_approved",
        align: "center",
      },
      {
        text: "Accountant",
        value: "is_finance_dir_approved",
        align: "center",
      },
      { text: "President", value: "is_president_approved", align: "center" },

      {
        text: "Action",
        value: "actions",
        align: "center",
        width: 100,
        sortable: false,
      },
    ],
    headers1: [
      { text: "TO Number", value: "travel_order_num", align: "start" },
      // { text: "Created By", value: "name", align: "start" },
      { text: "Employee/s", value: "to_names", align: "start", width: 180 },
      {
        text: "Date of Travel",
        value: "travel_date_from",
        align: "start",
        width: 100,
      },
      {
        text: "Place/s of Travel",
        value: "travel_place",
        align: "start",
        width: 180,
      },
      { text: "Purpose", value: "travel_purpose", align: "start", width: 180 },
      {
        text: "Recommending Approval",
        value: "is_recommending_approval_approved",
        align: "center",
      },
      {
        text: "Accountant",
        value: "is_finance_dir_approved",
        align: "center",
      },
      { text: "President", value: "is_president_approved", align: "center" },
      {
        text: "TAR Deadline",
        value: "tar_deadline",
        align: "center",
      },
      {
        text: "TAR Status",
        value: "tar_status",
        width: 250,
        align: "center",
      },
      {
        text: "Action",
        value: "actions",
        align: "center",
        width: 100,
        sortable: false,
      },
    ],
    tarFileName: null,
    tarDialogHeaders: [
      {
        text: "Name",
        value: "name",
        align: "start",
      },
      {
        text: "TAR Status",
        value: "status",

        align: "center",
      },
      {
        text: "Date Submitted",
        value: "date_submitted",

        align: "center",
      },
      {
        text: "Action",
        value: "action",
        align: "center",
      },
    ],
    data: [],
    verified: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    activeTab: { id: 1, name: "For Verification" },
    tab: 1,
    tabList: [
      { id: 1, name: "To receive" },
      { id: 2, name: "Received" },
      { id: 3, name: "Archived" },
      { id: 4, name: "Pending" },
      { id: 5, name: "Cancelled" },
    ],
    totalCount: 0,
    deleteData: null,
    updateData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    tarSubmitters: [],
    tarSubmitterDialog: false,
    tar_toID: null,
    paginationData: {},
    formdata: [],
    cancelTravelOrderDialog: false,
    itemToCancel: null,
    work_dates_menu: false,
    dialogConfirmDelete: false,

    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),

  mounted() {
    this.eventHub.$on("closeMyTravelOrderDialog", () => {
      this.initialize(this.tab);
    });
    this.eventHub.$on("closeViewTravelOrderAttachments", () => {
      this.initialize(this.tab);
    });
    this.eventHub.$on("ViewTravelOrderToUpdateDialog", () => {
      this.initialize(this.tab);
    });
    this.eventHub.$on("closeViewAttachmentDialog", () => {
      this.initialize(this.tab);
    });
    this.eventHub.$on("closeLateFilingTravelOrderDialog", () => {
      this.initialize(this.tab);
    });
    this.eventHub.$on("closeUpdateTravelOrderTypeDialog", () => {
      this.initialize(this.tab);
    });
  },
  beforeDestroy() {
    this.eventHub.$off("closeMyTravelOrderDialog");
    this.eventHub.$off("ViewTravelOrderToUpdateDialog");
    this.eventHub.$off("closeViewTravelOrderAttachments");
    this.eventHub.$off("closeViewAttachmentDialog");
    this.eventHub.$off("closeLateFilingTravelOrderDialog");
    this.eventHub.$off("closeUpdateTravelOrderTypeDialog");
  },
  watch: {
    options: {
      handler() {
        this.initialize(this.tab);
      },
      deep: true,
    },
  },

  methods: {
    formatTravelDate(item) {
      let dateStr = "";
      if (this.isValidJSON(item.travel_date_from)) {
        let data1 = JSON.parse(item.travel_date_from);

        if (data1.length > 2) {
          for (let i = 0; i < data1.length - 1; i++) {
            if (dateStr == "") {
              dateStr = this.formatDate(data1[i]);
            } else {
              dateStr += ", " + this.formatDate(data1[i]);
            }
          }
          dateStr += " & " + this.formatDate(item.travel_date_to);
        } else {
          let from = new Date(data1[0]);
          let end = new Date(item.travel_date_to);

          if (from.toDateString() === end.toDateString()) {
            dateStr = this.formatDate(data1[0]);
          } else {
            dateStr =
              this.formatDate(data1[0]) +
              " & " +
              this.formatDate(item.travel_date_to);
          }
        }

        this.travelDates = dateStr;
      } else {
        let from = new Date(item.travel_date_from);
        let end = new Date(item.travel_date_to);

        if (from.toDateString() === end.toDateString()) {
          dateStr = this.formatDate(from);
        } else {
          dateStr =
            this.formatDate(from) +
            " & " +
            this.formatDate(item.travel_date_to);
        }
      }
      return dateStr;
    },

    pagination(data) {
      this.paginationData = data;
    },
    getFirstDate(data) {
      let dump = JSON.parse(data);
      return dump[0];
    },

    isValidJSON(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    isNotDeadlineToday(date) {
      let today = new Date();
      let deadline = new Date(date);

      if (today.setHours(0, 0, 0, 0) <= deadline.setHours(0, 0, 0, 0)) {
        return true;
      } else {
        return false;
      }
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.initialize(tab.id);
      this.tab = tab.id;
    },

    initialize(status) {
      this.loading = true;
      if (status == 3) {
        this.axiosCall("/travel-order/archived", "GET").then((res) => {
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      } else if (status == 4) {
        this.axiosCall("/travel-order/pending", "GET").then((res) => {
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      } else if (status == 5) {
        this.axiosCall("/travel-order/cancelled", "GET").then((res) => {
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            console.log(data);
            this.loading = false;
          }
        });
      } else {
        this.axiosCall("/travel-order/receive/" + status, "GET").then((res) => {
          if (res) {
            let data = res.data;
            data.forEach((element, i) => {
              data[i].name = this.toTitleCase(element.name);
            });
            this.data = data;
            this.loading = false;
          }
        });
      }
    },

    // getVerifiedUsers() {
    //   this.loading = true;

    //   this.axiosCall("/user-details/getAllVerifiedUser", "GET").then((res) => {
    //     if (res) {
    //       this.data = [];

    //       this.data = res.data;
    //       this.loading = false;
    //     }
    //   });
    // },
    openTARSubmitters(item) {
      this.tar_toID = item.id;
      this.tarSubmitters = item.tarSubmitter;
      this.tarSubmitterDialog = true;
    },

    viewTarAttachment(id) {
      this.axiosCall("/tar/getAttachments/" + id, "GET").then((res) => {
        if (res.data) {
          // console.log("files", res.data);
          this.files_to_display = res.data;
          this.tarAttachSelectionDialog = true;
        }
      });
    },

    openAttachment(file) {
      this.tarAttachSelectionDialog = false;
      this.files_to_display = [];
      this.tarFileName = null;
      setTimeout(() => {
        this.tarFileName = file;
      }, 100);
    },

    printTAR(id) {
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/printEmployeeTAR/" +
        id +
        "/" +
        this.tar_toID;
      window.open(url);
    },

    add_late_filing() {
      this.late_filing = { id: null };
      this.action = "Add";
    },
    editItem(item) {
      this.updateData = item;
      this.action = "Update";
    },

    showToEdit(type) {
      this.editSelectionDialog = false;
      if (type == 1) {
        this.viewData = this.itemToEdit;
        this.action = "Update";
      } else {
        this.dataToUpdateType = this.itemToEdit;
        this.action = "Update";
      }
    },
    updateItem(item) {
      this.editSelectionDialog = true;
      this.itemToEdit = item;
      // this.viewData = item;
      // this.action = "Update";
    },
    submitCancellation() {
      this.cancelTravelOrderDialog = true;
    },
    cancelTO(item) {
      this.itemToCancel = item;
      this.cancelDialog = true;
    },

    confirmCancel() {
      const fd = new FormData();

      let data = {
        id: this.itemToCancel.id,
        description: this.cancel.reason,
      };
      fd.append("body", JSON.stringify(data));
      fd.append("file", this.cancel.attachment);
      // this.axiosCall(
      //   "/travel-order/cancelTO/" + this.itemToCancel.id,
      //   "PATCH",

      // ).then((res) => {
      this.axiosCall("/travel-order/cancelTO", "POST", fd).then((res) => {
        if (res.data.status == 200) {
          this.cancelTravelOrderDialog = false;
          this.cancelDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.initialize(this.tab);
        } else if (res.data.status == 400) {
          this.cancelTravelOrderDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    printItem(item) {
      const url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/printTravelOrder/" +
        item.id;
      window.open(url);
    },
    resetDeadLine(item) {
      console.log(item);
      this.travel_date_to = item.travel_date_to;
      this.to_ID = item.id;
      this.resetDeadlineDialog = true;
    },
    saveDeadlineDate() {
      if (this.$refs.resetDeadlineDialogFormref.validate()) {
        let data = {
          to_ID: this.to_ID,
          deadline_date: this.deadline_date,
        };
        this.axiosCall("/travel-order/reset-deadline", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.dialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.resetDeadlineDialog = false;
            } else if (res.data.status == 400) {
              this.dialog = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.resetDeadlineDialog = false;
            }
          },
        );
      }
    },
    // confirmDelete() {
    //   this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
    //     () => {
    //       this.fadeAwayMessage.show = true;
    //       this.itemData = null;
    //       this.initialize();
    //     }
    //   );
    // },

    generateTraveOrderApprovedApplication() {
      let filter = this.$store.getters.getFilterSelected;
      let url =
        process.env.VUE_APP_SERVER +
        "/pdf-generator/generateTraveOrderApprovedApplication/" +
        filter +
        "?dateFrom=" +
        this.date_from +
        "&dateTo=" +
        this.date_to;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    viewCancelledTO(item) {
      // let filter = this.$store.getters.getFilterSelected;
      let url =
        process.env.VUE_APP_SERVER +
        "/travel-order/getAttachments/" +
        item.filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      // this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.cancel-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.cancel-card {
  border-radius: 16px !important;
  overflow: hidden;
}

/* Header */
.dialog-header {
  background: linear-gradient(135deg, #147452 0%, #147452 100%);
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.header-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-title {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  margin-top: 2px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.15) !important;
}

/* Body */
.dialog-body {
  background: #f7f7f8;
  padding: 24px !important;
}

.section-card {
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 16px;
}

.section-header {
  display: flex;
  align-items: center;
}

.section-title {
  font-weight: 600;
  font-size: 15px;
  color: #212121;
}

.section-desc {
  font-size: 13px;
  color: #757575;
  margin-top: 2px;
  margin-left: 26px;
}

/* Footer */
.dialog-footer {
  background: #fff;
  padding: 16px 24px !important;
  border-top: 1px solid #eee;
}

.confirm-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.confirm-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.dialog-body {
  padding: 24px !important;
}

.confirm-text {
  font-size: 15px;
  color: #212121;
  margin-bottom: 6px;
}

.confirm-subtext {
  font-size: 13px;
  color: #9e9e9e;
  margin-bottom: 0;
}

.dialog-footer {
  padding: 12px 24px 20px !important;
}
</style>
